import React, { useEffect, useState } from "react";
import "./leadership.scss";
import { NavHashLink } from "react-router-hash-link";
import Spinner from "../Spinner/Spinner";
import parse from "html-react-parser";

import config from "../../config";

const BASE_URL = config.base_url;

const uploadUrl = `${BASE_URL}storage/team-member/`;
const getLeadersUrl = `${BASE_URL}api/get-leaders`;

const Leadership = () => {
  const [error, setError] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [items, setItems] = useState([]);

  useEffect(() => {
    const getLeaders = async () => {
      setIsLoading(true);
      setError("");
      try {
        const response = await fetch(getLeadersUrl);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        setItems(result);
      } catch (error) {
        console.log(error, "error while fetching leaders");
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };
    // fetch(getLeadersUrl)
    //   .then((res) => res.json())
    //   .then(
    //     (result) => {
    //       setIsLoaded(true);
    //       setItems(result);
    //     },
    //     (error) => {
    //       setIsLoaded(true);
    //       setError(error);
    //     }
    //   );
    getLeaders();
  }, []);

  // if (error) {
  //   return <div>Error: {error.message}</div>;
  // } else if (!isLoaded) {
  //   return (
  //     <div>
  //       <Spinner />
  //     </div>
  //   );
  // } else {
  return (
    <section id="leaders">
      <div className="container ">
        <div className="row justify-content-center text-center ">
          {isLoading ? (
            <Spinner />
          ) : error ? (
            <div className="error-message">Error: {error.message}</div>
          ) : (
            items?.data?.length ? items?.data?.map((data) => (
              <div className="col-sm-6 col-lg-3 mb-3 " key={data.id}>
                <div className="box shadow-sm p-4">
                  <div className="image-wrapper mb-3 ">
                    <img
                      className=""
                      src={`${uploadUrl}${data.image}`}
                      alt="..."
                    />
                  </div>
                  <div className="box-desc mb-2">
                    <h5>{data.name}</h5>
                    <h5>{parse(data.designation)}</h5>
                  </div>
                  <ul className="social">
                    <li>
                      {/* <NavHashLink to={`/leadership/${data.slug}#`}>
                        <button className="buttonStyle">Know More</button>
                      </NavHashLink> */}
                      {/* <a
                        href={data.linkedin_url}
                        rel="noreferrer"
                        target="_blank"
                      >
                        <i className="fab fa-linkedin"></i>
                      </a> */}
                    </li>
                  </ul>
                </div>
              </div>
            )) : (
              <div>No Data found</div>
            )
          )}
        </div>
      </div>
    </section>
  );
  // }
};
export default Leadership;
